<template>
  <div class="d-flex align-items-start mr-5 ml-5" id="individual_ticket">
    <div class="border rounded" :class="ticketType == 1 ? 'w-100' : 'w-75'">
      <div class="bg-base d-center-start pt-3 pb-3 pl-2 pr-2">
        <i class="iconfont text-blue" style="font-size: 24px;">&#xe6b9;</i>
        <h4 class="mb-0 ml-2 mr-2 font-weight-bold" v-if="!productId">
          {{storeName}}（{{ticketType == 1 ? '团队票' : '散客票'}}）
        </h4>
        <h4 class="mb-0 ml-2 mr-2 font-weight-bold" v-else>订单详情</h4>
      </div>
      <div class="mt-5 mb-5">
        <!--购买景区散客票信息-->
        <div v-if="!productId">
          <div class="mb-5">
            <div class="d-flex align-items-center pl-4">
              <left-text leftText="日期"/>
              <el-date-picker v-model="pickDate"
                              type="date" size="small"
                              :picker-options="startDateLimit"
                              value-format="timestamp"
                              placeholder="选择日期" />
            </div>
            <div class="d-flex align-items-center pl-4 mt-3" v-if="ticketType == 1">
              <left-text leftText="客源地"/>
              <select-city style="margin-left: -60px" @getCityInfo="getCityInfo" :secondMode="false" :thirdMode="false"/>
            </div>
          </div>
          <div v-for="(item,index) in selectedTickets" :key="item.id" class="pl-4 pr-4 mb-4">
            <div class="d-flex align-items-center ml-2 mb-2">
              <span class="text-muted h5 mb-0">{{item.ticket_species | formatVar('ticketTypeArr')}}</span>
              <span class="ml-2">（{{item.name}}）</span>
              <span class="text-muted cursor-pointer"
                    @click="showTipIndex===item.id ? showTipIndex='' : showTipIndex=item.id">{{showTipIndex===item.id ? '收起': '展开'}}
                <i class="iconfont" v-if="showTipIndex===item.id ">&#xe6b0;</i>
                <i class="iconfont" v-else>&#xe665;</i>
              </span>
              <a v-if="ticketType != 1" href="javascript:;" class="ml-auto text-primary" @click="selectedTickets.splice(index,1)">删除</a>
            </div>
            <!--门票展开详情-->
            <transition name="fade">
              <div v-show="showTipIndex===item.id">
                <div class="bg-base text-left p-3" v-for="(childValue,childKey) in tipObj" :key="childKey">
                  <h5>{{childValue}}：</h5>
                  <p v-html="item[childKey]"></p>
                </div>
              </div>
            </transition>
            <!--门票数量-->
            <div class="d-flex align-items-center mt-4 pb-4" v-if="ticketType == 2">
              <left-text leftText="数量"/>
              <el-input-number v-model.number="selectedTickets[index].num" @change="ctrlNum(index,$event)" :min="1" class="input-width"/>
            </div>
            <div class="mt-4 mb-4 text-left" v-if="item.scene.length > 0">
              <div class="inline"><left-text leftText="场次" /></div>
              <el-row class="w-85 inline pr-3" :gutter="10">
                <el-col :span="3" v-for="(v, ind) in item.scene" :key="ind">
                  <div :class="{'bactive': selectedTickets[index].sceneId == v.id}"
                  class="border rounded p-2 mb-2 text-center" @click="ctrlScene(index, v.id)">{{v.date}}</div>
                </el-col>
              </el-row>
            </div>
            <div v-if="item.seat.length > 0">
              <div class="inline"><left-text leftText="座位区域" /></div>
              <el-row class="w-85 inline pr-3" :gutter="10">
                <div class="text-right text-link mt-2 mb-2" v-if="item.seat_pic.length > 0" @click="imgPreview(item,index)">查看座位图</div>
                <el-col :span="8" v-for="(v, ind) in item.seat" :key="ind">
                  <div :class="{'oactive': selectedTickets[index].seatId == v.id}"
                  class="border rounded mb-2 p-2 text-left" @click="ctrlSeat(index, v.id, v.price3)"><span class="w-65 inline">{{v.seat_name}}</span><span class="w-35 inline">¥{{v.price3}}</span></div>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="m-4 pt-5 pb-4 border-top">
            <el-button class="ml-auto mr-auto" @click="dialogVisible=true">添加更多门票</el-button>
          </div>
          <div class="text-right mt-2 mr-4 mb-2" v-if="ticketType == 1">总计金额：<span class="text-danger font-weight-bold h4">&yen; {{totalPrice}}</span></div>
          <el-table :data="selectedTickets" class="ml-4 mr-4" style="width: 95%" v-if="ticketType == 1">
            <el-table-column label="门票种类">
              <template slot-scope="scope">
                <span>{{scope.row.ticket_species | formatVar('ticketTypeArr')}}</span>
                <span class="ml-1">（{{scope.row.name}}）</span>
              </template>
            </el-table-column>
            <el-table-column label="数量">
              <template slot-scope="scope">
                <el-input-number v-model.number="selectedTickets[scope.$index].num" @change="ctrlNum(scope.$index,$event)" :min="1" size="mini" />
              </template>
            </el-table-column>
            <el-table-column label="单价">
               <template slot-scope="scope">{{scope.row.price3}} 元</template>     
            </el-table-column>
            <el-table-column label="在线立减">
               <template slot-scope="scope">{{(scope.row.num * scope.row.discount).toFixed(2)}} 元</template>     
            </el-table-column>
            <el-table-column label="总计">
              <template slot-scope="scope">{{(scope.row.num * Number(scope.row.price3)).toFixed(2)}}元</template>    
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope"><span class="text-link" @click="selectedTickets.splice(scope.$index,1)">删除</span></template>
            </el-table-column>
          </el-table>
        </div>
        <!--购买度假产品信息-->
        <div v-if="productId" class="pl-4">
          <div class="d-center-start"><left-text leftText="名称"/>{{DisplayBasicInfo.title}}</div>
          <div class="d-center-start mt-4"><left-text leftText="价格"/>
            <label class="text-info h2"> &yen; {{Price.price3}}</label>
            <label class="text-muted ml-4" style="text-decoration: line-through"> &yen;{{Price.price1}} 原价</label>
          </div>
          <div class="d-flex align-items-center mt-4">
            <left-text leftText="数量"/>
            <div class="d-center">
              <i class="iconfont cursor-pointer text-blue" style="font-size: 16px;"
                 @click="ctrolNum(-1)">&#xe6f2;</i>
              <input type="number" class="product-num" v-model.number="productNum" @blur="formatNum">
              <i class="iconfont cursor-pointer text-blue" style="font-size: 16px;"
                 @click="ctrolNum(1)">&#xe613;</i>
            </div>
          </div>
          <div class="d-flex align-items-center mt-4" v-if="DisplayBasicInfo.type == 1">
            <left-text leftText="出行日期"/>
            <!-- <el-date-picker v-model="pickDate"
                            type="date"
                            :picker-options="productDateLimit"
                            value-format="timestamp"
                            placeholder="选择日期" /> -->
            <el-button @click="showCalendar = !showCalendar">{{pickDate1}}</el-button>
          </div>
          <transition name="fade">
            <div class="m-4 vocalendar" v-show="showCalendar">
              <!--日期选择头-->
              <div class="picker-header">
                <div class="header-date">{{year}}-{{month}}</div>
                <div class="pre-month" @click="updateDayList(-1)" v-show="leftArrow">
                  <i class="iconfont">&#xe83f;</i>
                </div>
                <div class="next-month" @click="updateDayList(1)" v-show="rightArrow">
                  <i class="iconfont">&#xe620;</i>
                </div>
              </div>
              <!--周一到周日-->
              <div class="picker-weekday">
                <div class="clearfix w-100">
                  <span>日</span>
                  <span>一</span>
                  <span>二</span>
                  <span>三</span>
                  <span>四</span>
                  <span class="bg-warning text-danger">五</span>
                  <span class="bg-warning text-danger">六</span>
                </div>
              </div>
              <!--循环渲染每天的数据-->
              <div style="background: #eeeeee;">
                <div class="picker-days clearfix d-flex" v-for="(item,index) in days" :key="index">
                  <div class="day-wrap" :title="year+'-'+month +'-'+dateTime.day" @click="goToOrder(dateTime,index)"
                    :class="{'disabled': noShow(dateTime,index)}"  v-for="(dateTime,index) in item" :key="index">
                    <span>{{dateTime.day ? dateTime.day : '-'}}<span style="font-size: 12px;font-weight: normal">号</span></span>
                    <div class="info-wrap" :class="noShow(dateTime,index) ? 'text-disabled' : 'text-danger'">
                      &yen;{{dateTime.price3 ? dateTime.price3 : '-'}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
        <div v-if="ticketType != 1">
          <div class="bg-base d-flex align-items-center pt-3 pb-3 pl-2 pr-2 mt-5">
            <i class="iconfont text-blue" style="font-size: 24px;">&#xe681;</i>
            <h4 class="mb-0 ml-2 mr-2 font-weight-bold">联系人信息</h4>
            <span class="text-danger">（必填项）</span>
          </div>
          <div class="d-flex align-items-center mt-5 pl-4">
            <left-text leftText="姓名"/>
            <el-input class="input-width" v-model="linkMan" placeholder="请输入姓名"/>
          </div>
          <div class="d-flex align-items-center mt-2 pl-4">
            <left-text leftText="手机号码"/>
            <el-input class="input-width" v-model="linkPhone" placeholder="请输入手机号码"/>
          </div>
          <div class="d-flex align-items-center mt-2 pl-4">
            <left-text leftText="身份证号"/>
            <el-input class="input-width" v-model="linkIDNum" placeholder="请输入身份证号"/>
          </div>
        </div>
        <div v-else class="m-4 text-left">
          <div class="mb-3">备注信息：</div>
          <el-input type="textarea" :rows="4" placeholder="请输入备注信息" v-model="textarea" />
          <div class="bg-base d-flex align-items-center pt-3 pb-3 pl-2 pr-2 mt-5">
            <i class="iconfont text-blue" style="font-size: 24px;">&#xe681;</i>
            <h4 class="mb-0 ml-2 mr-2 font-weight-bold">联系人信息</h4>
          </div>
          <el-row class="m-4">
            <el-col :span="12">姓名：{{userLoginMessage.name}}</el-col><el-col :span="12">手机号码：{{$route.query.mobile}}</el-col>
          </el-row>
        </div>
        <el-button type="primary" v-if="ticketType == 1" class=" w-15 mt-5" @click="submitGroup">提交订单</el-button>
        <el-button type="primary" v-else class=" w-15 mt-5" @click="submitForm">提交订单</el-button>
        <!--选择更多门票-->
        <transition name="fade">
          <scenic-ticket-opt :tickets="tickets" v-show="dialogVisible" @chooseTicket="chooseTicket"
                             :checkedTicket="selectedTickets"/>
        </transition>
      </div>
    </div>
    <div class="w-25 ml-4 border rounded text-left" v-if="ticketType != 1">
      <h4 class="bg-base text-muted border-bottom rounded p-3">费用明细</h4>
      <div class="p-3">
        <div v-for="(item,index) in selectedTickets" class="mb-3" :key="index">
          <div class="d-flex align-items-center flex-wrap">
            <span class="text-muted h5 mb-1">{{item.ticket_species | formatVar('ticketTypeArr')}}</span>
            <span class="ml-1">({{$GFUN.formatString(5,item.name)}})</span>
            <span class="ml-auto" v-if="item.seatPrice3 > 0">{{item.num}} x &yen;{{item.seatPrice3}}</span>
            <span class="ml-auto" v-else>{{item.num}} x &yen;{{Price.price3 || item.price3}}</span>
          </div>
          <p class="text-info mt-2 mb-0 text-right" v-show="item.discount>0">在线立减 &yen;{{(item.num *
            item.discount).toFixed(2)}}</p>
        </div>
      </div>
      <h4 class="bg-base text-muted rounded d-flex mb-0 p-3">
        <span>应付金额</span>
        <span class="text-info ml-auto">&yen; {{totalPrice}}</span>
      </h4>
    </div>
  </div>
</template>

<script>
  import {mapState,mapGetters, mapActions} from 'vuex'
  import ScenicTicketOpt from './ScenicTicketOpt'

  export default {
    name: 'ScenicIndividualTicket',
    components: {ScenicTicketOpt},
    props: {
      initChosen: {},
      tickets: {},
      // scene: {
      //   type: Array,
      //   default: function () {return []}
      // },
    },
    data() {
      return {
        showPic: false,
        pickDate: '',
        pickDate1: '选择出行日期',
        startDateLimit: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 8.46e7;
          },
        },
        productDateLimit:{},
        productNum:'',
        linkMan: '',
        linkPhone: '',
        linkIDNum: '',
        selectedTickets: [],
        showTipIndex: '',
        tipObj: {
          description1: '费用包含',
          description2: '入园方式',
          description3: '重要提示',
          description4: '退改规则',
        },
        dialogVisible: false,
        showCalendar: false,
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        nowTime: new Date(new Date().toLocaleDateString()).getTime() / 1000,
        leftArrow: false,
        rightArrow: true,
        days: [],
        Price: {
          price1: '',
          price3: ''
        },
        newSplit: [],
        inOut: {
          date_in: '',
          date_out: '',
        },
        textarea: '',
        province: '',
        city: ''
      }
    },
    created() {
      if (this.productId) this.productNum = Number(this.$route.query.num) || '';
    },
    computed: {
      ...mapState(['userLoginMessage', 'ScenicTicketsOpt', 'RouterId','DisplayBasicInfo']),
      ...mapGetters(['storeInfo','isGroup']),
      storeId() { return this.$route.query.store },
      productId() { return this.$route.query.productId },
      storeName() { return this.$route.query.name  },
      ticketType () { return this.$route.query.ticketType },
      totalPrice() {
        let price = 0;
        this.selectedTickets.forEach(v => {
          if (v.seatPrice3) price += Number(v.num * (v.seatPrice3 - v.discount));
          else price += Number(v.num * (v.price3 - v.discount));
        });
        return price.toFixed(2);
      },
    },
    watch: {
      initChosen(newVal) {
        newVal.num = 1;        //初始化选择门票为1
        // 如果有座位和场次就加上场次与座位ID
        if (this.userLoginMessage.type == 2) { newVal.sceneId = ''; newVal.seatId = ''; newVal.seatPrice3 = 0; }
        this.selectedTickets.push(newVal)
      },
      RouterId() {
        if (this.RouterId !== '') {
          this.$alert('提交成功！', '提示', {type: 'success', center: true}).then(() => {
            this.$router.push({name: 'OrderDetail', query: {orderType: '6', orderId: this.RouterId,storeId: this.$route.query.storeId}});
          })
        }
      },
      DisplayBasicInfo(newVal) {
        this.Price.price1 = this.DisplayBasicInfo.price1
        this.Price.price3 = this.DisplayBasicInfo.price3
        let arr = newVal.buy_time.split(',');
        if (arr.includes('7')) {
          arr.splice(arr.length - 1,1,'0')
          this.newSplit = arr
        } else {
          this.newSplit = arr
        }
        this.inOut.date_in = this.formatTimestamp(newVal.date_in)
        this.inOut.date_out = this.formatTimestamp(newVal.date_out)
        this.year = this.nowTime < newVal.date_in  ? Number(this.inOut.date_in.substring(0,4)) : this.year
        this.month = this.nowTime < newVal.date_in  ? Number(this.inOut.date_in.substring(5,7)) : this.month
        if (this.year == this.inOut.date_out.substring(0,4) && this.month == this.inOut.date_out.substring(5,7)) {
          this.rightArrow = false
        } else {
          this.rightArrow = true
        }
        this.getVocationCalendar()
        // //可购买的日期
        // arr = arr.map(v => {
        //   if (v === '7') return 0
        //   else return Number(v)
        // });
        // let week,allowBuy;
        // //获取到可购买日期返回值后，禁用不可购买的日期
        // this.productDateLimit = {
        //   disabledDate(time) {
        //     week = time.getDay();
        //     //时间戳转换为周几时判断是否为可购买日期
        //     allowBuy = (arr.filter(v => v === week)[0]) !== undefined;
        //     return (time.getTime() < Date.now() - 8.46e7) || !allowBuy;
        //   },
        // }
        //右侧价格总计
        this.selectedTickets = [{
          num:this.productNum,
          price3:newVal.price3,
          name:newVal.title,
          discount:0
        }]
      }
    },
    methods: {
      ...mapActions(['ScenicIndiviReserve','postProductOrder','ScenicGroupReserve']),
      getCityInfo(info) {
        this.city = info.city;
        this.province = info.province;
      },
      //时间戳转换为年月日
      formatTimestamp: (timestamp) => {
        if (!timestamp) return ''               //时间戳为空时返回空
        let date = new Date(timestamp * 1000)
        let y = date.getFullYear()
        let m = date.getMonth() + 1
        m = m < 10 ? '0' + m : m
        let d = date.getDate()
        d = d < 10 ? '0' + d : d
        return y + '-' + m + '-' + d
      },
      // 获取提交订单时度假产品日历
      async getVocationCalendar () {
        let resData = await this.$axios.post('pc/Reglogin/roomCalendar', {
          store_id: this.productId,
          store_type: '7',
          room_id: this.productId,
          //year_day: this.year + '-' + (this.month < 10 ? '0' + this.month : this.month)
          year_day: this.year + '-' + this.month 
        })
        if (resData.code === '00000') {
          this.days = resData.info
        }
      },
      /*更新房型日历列表*/
      updateDayList(index) {
        this.days = [];
        this.month += index;
        if (this.month <= 0) {
          this.month = 12;
          this.year--;
        }
        if (this.month > 12) {
          this.month = 1;
          this.year++;
        }
        let today = new Date();
        /*逻辑判断左箭头是否显示*/
        if (this.year > today.getFullYear()) {
          this.leftArrow = true;
        } else if (this.year === today.getFullYear()) {
          this.leftArrow = this.month > today.getMonth() + 1;
        }
        if (this.year == this.inOut.date_in.substring(0,4) && this.month == this.inOut.date_in.substring(5,7)) {
          this.leftArrow = false;
        }
        if (this.year == this.inOut.date_out.substring(0,4) && this.month == this.inOut.date_out.substring(5,7)) {
          this.rightArrow = false
        } else {
          this.rightArrow = true
        }
        this.getVocationCalendar()
      },
      /*点击日历绑定数据*/
      goToOrder(dateTime,index) {
        if (this.noShow(dateTime,index)) return
        this.Price.price1 = dateTime.price1
        this.Price.price3 = dateTime.price3
        this.selectedTickets[0].price3 = dateTime.price3
        let time = this.year + '-' + this.month + '-' + dateTime.day;
        this.pickDate1 = time
        let date = new Date(time);
        this.pickDate = Math.round(date.getTime())
        this.showCalendar = false
      },
      //所有不应该显示的日期(1、今天之前的 2、使用日期之前的 3、不在星期使用范围的 4、使用日期之后的)
      noShow(dateTime,index) {
        if (dateTime.day) {
          // 当前日历每个日子的时间戳
          let concrete = (new Date(this.year + '-' + this.month + '-' + dateTime.day)).getTime() / 1000
          if (concrete < this.DisplayBasicInfo.date_in ||
              concrete > (this.DisplayBasicInfo.date_out + 28800) ||
              !this.newSplit.includes(String(index)) ||
              concrete < this.nowTime
          ) { return true }
        } else return true
      },
      /*加减门票数量*/
      ctrlNum(index, value) {
        let item = this.selectedTickets[index];
        item.num = value;
        this.$set(this.selectedTickets, index, item);
      },
      /*勾选场次 */
      ctrlScene(index, value) {
        let item = this.selectedTickets[index];
        item.sceneId = value;
        this.$set(this.selectedTickets, index, item);
      },
      /*勾选座位 */
      ctrlSeat(index, value, price3) {
        let item = this.selectedTickets[index];
        item.seatId = value;
        item.seatPrice3 = Number(price3)
        this.$set(this.selectedTickets, index, item);
      },
      //图片放大
      imgPreview(item, index) {
        this._CarouselView({
          currentImg: index,
          picArray: item.seat_pic.split(',')
        })
      },
      //加减购买度假产品数量
      ctrolNum(flag) {
        if (this.productNum + flag <= 0) {
          this.productNum = 1;
          return;
        }
        this.productNum += flag;
        this.$set(this.selectedTickets, 0, {
          num:this.productNum,
          // price3:this.DisplayBasicInfo.price3,
          price3:this.Price.price3,
          name:this.DisplayBasicInfo.title,
          discount:0
        });
      },
      //直接修改购买度假产品数量时失焦校验
      formatNum() {
        if (this.productNum <= 0) this.productNum = 1;
        this.$set(this.selectedTickets, 0,{
          num:this.productNum,
          price3:this.DisplayBasicInfo.price3,
          name:this.DisplayBasicInfo.title,
          discount:0
        });
      },
      /*添加更多门票*/
      chooseTicket(values) {
        this.dialogVisible = false;
        if (values) {
          let ids = this.selectedTickets.map(v => v.id);
          values.forEach(id => {
            if (!this.$GFUN.isInArray(ids, id)) {
              let item = this.tickets.filter(v => v.id == id)[0];
              item.num = 1;
              if (this.userLoginMessage.type == 2) { item.sceneId = ''; item.seatId = ''; item.seatPrice3 = 0; }
              this.selectedTickets.push(item);
            }
          })
        }
      },
      /*验证表单数据*/
      validateForm() {
        if (!this.pickDate && this.DisplayBasicInfo.type == 1) return {code: false, msg: '请选择日期'};
        if (!this.productId) {          //添加景区散客票
          if (this.selectedTickets.length < 1) return {code: false, msg: '请至少添加一张门票'};
          for (let i = 0; i < this.selectedTickets.length; i++) {
            if (!this.$GFUN.isPositiveInteger(this.selectedTickets[i].num)) return {code: false, msg: '门票数量必须为正整数'};
          }
        }
        if (!this.$GFUN.isName(this.linkMan)) return {code: false, msg: '请填写正确的联系人姓名'};
        if (!this.$GFUN.isPhone(this.linkPhone)) return {code: false, msg: '请填写正确的联系人手机号码'};
        if (!this.$GFUN.isIDexist(this.linkIDNum)) return {code: false, msg: '请填写正确的身份证号码'};
        return {code: true, msg: '表单验证通过'}
      },
      // 团队票提交订单
      submitGroup() {
        if (!this.pickDate) { this.$message.warning('请选择日期！'); return }
        if (!this.province) { this.$message.warning('请选择客源地！'); return }
        for (const key in this.selectedTickets) {
          if (this.selectedTickets[key].scene.length > 0 && !this.selectedTickets[key].sceneId) { this.$message.warning('请选择场次'); return }
        }
        this.$confirm('确认提交订单吗','提示', { type: 'warning',center:true }).then(() => {
          let tickets = this.selectedTickets.map(v => ({id: v.id, num: v.num, scene: v.sceneId}));
          this.ScenicGroupReserve({
            data:{
              store_id : this.isGroup ? this.$route.query.storeId :this.storeInfo.storeId,
              date_in : this.pickDate / 1000,
              remark : this.textarea,
              source_province : this.province,
              source_city : this.city,
              viewpoint_id : this.storeId,
              ticket: tickets
            },
            successFun: (res) => {
              this.$alert('提交成功', '提示', {
                type:'success',
                center:true,
                callback: () => {
                  this.$router.push({path:'/index/index_scenic/shop_car',query:{show:'group',orderId: res.id, ticketType: 1,storeId: this.$route.query.storeId}});
                }
              })
            }
          })
        }).catch(() => {});
      },
      /*度假产品提交订单*/
      async voactionSubmit() {
        let res = await this.postProductOrder({
          product_id:this.productId,
          num:this.productNum,
          date_in: this.pickDate / 1000,
          occupant_name: this.linkMan,
          occupant_mobile: this.linkPhone,
          id_card: this.linkIDNum,
        });
        this.$router.push({name:'VocationQR',query:{id:res, type:7}});
      },
      /*提交表单*/
     submitForm() {
        if (this.userLoginMessage.type == 2 && !this.productId) {
          for (const key in this.selectedTickets) {
            if (this.selectedTickets[key].scene.length > 0 && !this.selectedTickets[key].sceneId) { this.$message.warning('请选择场次'); return }
            if (this.selectedTickets[key].seat.length > 0 && !this.selectedTickets[key].seatId) { this.$message.warning('请选择座位'); return }
          }
        }
        let result = this.validateForm();
        if (result.code) {
          this._confirm('确认提交订单吗', () => {
            let tickets = this.selectedTickets.map(v => ({id: v.id, num: v.num, scene: v.sceneId, seat: v.seatId}));
            if (!this.productId) {       //提交景区散客票
              this.ScenicIndiviReserve({
                data: {
                  store_id: this.isGroup ? this.$route.query.storeId :this.storeInfo.storeId,
                  viewpoint_id: this.storeId,
                  date_in: this.pickDate / 1000,
                  occupant_name: this.linkMan,
                  occupant_mobile: this.linkPhone,
                  id_card: this.linkIDNum,
                  ticket: tickets,
                },
              });
            } else this.voactionSubmit();
          });
        } else this._alert(result.msg, null, 'error');
      },
    }
  }
</script>
<style scoped lang="scss">
  .inline{
    vertical-align: top
  }
  .bactive{
    border: 1px solid  var(--smtc-color-primary)!important;
    color:  var(--smtc-color-primary) 
  }
  .oactive{
    border: 1px solid #FF8800!important;
    color: #FF8800
  }
  .input-width {
    width: 220px;
    height: 40px;
  }
  .product-num {
    width: 80px!important;
  }
  .picker-header {
    padding: 5px;
    font-family: "Adobe 楷体 Std R";
    font-size: 14px;
    font-weight: bolder;
    position: relative;
    text-align: center;
    background: #ddd;
    .pre-month {
      position: absolute;
      top: 5px;
      left: 20px;
      cursor: pointer;
    }
    .next-month {
      position: absolute;
      top: 5px;
      right: 20px;
      cursor: pointer;
    }
  }
  .pr-3{
    padding-right: 0!important;
    margin-top: -7px
  }
  .pr-3:hover{
    cursor: pointer;
  }
  .picker-weekday {
    div {
      padding: 0;
      margin: 0;
      background: #000;
      span {
        width: 14.1%;
        background: #000;
        text-align: center;
        padding: 5px 0;
        color: #ffc107;
        font-weight: bolder;
      }
    }
    span {
      display: inline-block;
      width: 14.1%;
      font-weight: bolder;
      background: #3996d7;
      text-align: center;
      font-size: 16px;
    }
  }
  .vocalendar{
    min-height: 390px
  }
  .picker-days {
    background: #eee;
    .day-wrap {
      background: rgba(0, 0, 0, 0);
      width: 14.1%;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      border-radius: 3px;
      font-size: 12px;
      color: #555;
      text-decoration: none;
      cursor: pointer;
      margin-bottom: 5px;
      &:hover {
        box-shadow: 2px 2px 2px rgba(0, 0, 0, .6);
        background: rgba(123, 123, 123, .1);
      }
      .day-list {
        font-size: 16px;
        font-weight: bolder;
        color: #000;
      }
      .info-wrap {
        display: flex;
        flex-direction: column;
        text-align: left;
      }
    }
    .disabled {
      cursor: default;
      span {
        color: #ddd;
      }
      &:hover {
        box-shadow: none;
        background: rgba(0, 0, 0, 0);
      }
    }
  }
</style>
